import { Injectable } from '@angular/core';
import { OrderStatusEnum } from '../../enum/orders/status.enum';

export enum Status {
    Open = 'Aberta',
    Canceled = 'Cancelada',
    Closed = 'Fechada'
}

export enum Substatus {
    PENDING_NEW_RISK = 'Pendente',
    PENDING_NEW_TRADE_CONECTOR = 'Pendente',
    PENDING_REPLACE_RISK = 'Pendente',
    PENDING_REPLACE_TRADE_CONECTOR =  'Pendente',
    PENDING_CANCEL_RISK = 'Cancelamento pendente',
    PENDING_CANCEL_TRADE_CONECTOR = 'Cancelamento pendente',
    PENDING_NEW_EXCHANGE = 'Pendente',
    PENDING_REPLACE_EXCHANGE = 'Pendente',
    PENDING_CANCEL_EXCHANGE = 'Cancelamento pendente',
    PENDING_TRIGGER = 'Pendente',
    NEW = 'Nova',
    PARTIALLYFILLED = 'Parcialmente executada',
    FILLED = 'Totalmente executada',
    CANCELED = 'Você cancelou',
    REPLACED = 'Editada',
    REJECTED = 'Rejeitada',
    SUSPENDED = 'Suspendida',
    EXPIRED = 'Expirada',
    CANCELEDBYEVENT = 'Cancelada por evento',
    SCHEDULEDREPLACEMENT = 'Edição agendada',
    SCHEDULEDCANCELATION = 'Cancelamento agendado',
    SCHEDULEDNEW = 'Nova agendada'
}

class OrderStatus {

    constructor(public Status: Status, public Substatus: Substatus, public ID: number) {}

}

@Injectable()
export class OrdersService {

    constructor (){}

    public translateOrderStatus (historyItem: any): OrderStatus {
        switch(historyItem.status) {
            // abertas
            case OrderStatusEnum.NEW: 
                return new OrderStatus(Status.Open, Substatus.NEW, OrderStatusEnum.NEW);
            case OrderStatusEnum.REPLACED: 
                return new OrderStatus(Status.Open, Substatus.REPLACED, OrderStatusEnum.REPLACED);
            case OrderStatusEnum.PENDING_CANCEL_EXCHANGE: 
                return new OrderStatus(Status.Open, Substatus.PENDING_CANCEL_EXCHANGE, OrderStatusEnum.PENDING_CANCEL_EXCHANGE);
            case OrderStatusEnum.PENDING_CANCEL_RISK: 
                return new OrderStatus(Status.Open, Substatus.PENDING_CANCEL_RISK, OrderStatusEnum.PENDING_CANCEL_RISK);
            case OrderStatusEnum.PENDING_CANCEL_TRADE_CONECTOR: 
                return new OrderStatus(Status.Open, Substatus.PENDING_CANCEL_TRADE_CONECTOR, OrderStatusEnum.PENDING_CANCEL_TRADE_CONECTOR); 
            case OrderStatusEnum.SUSPENDED: 
                return new OrderStatus(Status.Open, Substatus.SUSPENDED, OrderStatusEnum.SUSPENDED);
            case OrderStatusEnum.PENDING_NEW_EXCHANGE: 
                return new OrderStatus(Status.Open, Substatus.PENDING_NEW_EXCHANGE, OrderStatusEnum.PENDING_NEW_EXCHANGE);
            case OrderStatusEnum.PENDING_NEW_RISK: 
                return new OrderStatus(Status.Open, Substatus.PENDING_NEW_RISK, OrderStatusEnum.PENDING_NEW_RISK);
            case OrderStatusEnum.PENDING_NEW_TRADE_CONECTOR: 
                return new OrderStatus(Status.Open, Substatus.PENDING_NEW_TRADE_CONECTOR, OrderStatusEnum.PENDING_NEW_TRADE_CONECTOR);
            case OrderStatusEnum.PENDING_REPLACE_EXCHANGE: 
                return new OrderStatus(Status.Open, Substatus.PENDING_REPLACE_EXCHANGE, OrderStatusEnum.PENDING_REPLACE_EXCHANGE);
            case OrderStatusEnum.PENDING_REPLACE_RISK: 
                return new OrderStatus(Status.Open, Substatus.PENDING_REPLACE_RISK, OrderStatusEnum.PENDING_REPLACE_RISK);
            case OrderStatusEnum.PENDING_REPLACE_TRADE_CONECTOR: 
                return new OrderStatus(Status.Open, Substatus.PENDING_REPLACE_TRADE_CONECTOR, OrderStatusEnum.PENDING_REPLACE_TRADE_CONECTOR);
            case OrderStatusEnum.PENDING_TRIGGER: 
                return new OrderStatus(Status.Open, Substatus.PENDING_TRIGGER, OrderStatusEnum.PENDING_TRIGGER);
            case OrderStatusEnum.PARTIALLYFILLED: 
                return new OrderStatus(Status.Open, Substatus.PARTIALLYFILLED, OrderStatusEnum.PARTIALLYFILLED);
            case OrderStatusEnum.SCHEDULEDNEW:
                return new OrderStatus(Status.Open, Substatus.SCHEDULEDNEW, OrderStatusEnum.SCHEDULEDNEW);
            case OrderStatusEnum.SCHEDULEDREPLACEMENT:
                return new OrderStatus(Status.Open, Substatus.SCHEDULEDREPLACEMENT, OrderStatusEnum.SCHEDULEDREPLACEMENT);
            case OrderStatusEnum.SCHEDULEDCANCELATION:
                return new OrderStatus(Status.Open, Substatus.SCHEDULEDCANCELATION, OrderStatusEnum.SCHEDULEDCANCELATION);

            // Fechada
            case OrderStatusEnum.FILLED: 
                return new OrderStatus(Status.Closed, Substatus.FILLED, OrderStatusEnum.FILLED)

            // Cancelada
            case OrderStatusEnum.CANCELED: 
                return new OrderStatus(Status.Canceled, Substatus.CANCELED, OrderStatusEnum.CANCELED)
            case OrderStatusEnum.REJECTED: 
                return new OrderStatus(Status.Canceled, Substatus.REJECTED, OrderStatusEnum.REJECTED)
            case OrderStatusEnum.EXPIRED: 
                return new OrderStatus(Status.Canceled, Substatus.EXPIRED, OrderStatusEnum.EXPIRED)
            case OrderStatusEnum.CANCELEDBYEVENT: 
                return new OrderStatus(Status.Canceled, Substatus.CANCELEDBYEVENT, OrderStatusEnum.CANCELEDBYEVENT)
            
            default:
                return new OrderStatus(Status.Canceled, Substatus.EXPIRED, OrderStatusEnum.EXPIRED)
        }

    }

}

